const initialState = null;

export default function shoppingCartError(state = initialState, { payload, type }) {
  switch (type) {
    // GET SYSTEMS
    case 'SHOPPING_CART_SEND_PRODUCTS_REQUEST':
      return null;
    case 'SHOPPING_CART_SEND_PRODUCTS_SUCCESS':
      return null;
    case 'SHOPPING_CART_SEND_PRODUCTS_FAILURE':
      return payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/shopping-cart-error.js